import getDOMfromString from '../../../helpers/getDOMfromString';

/**
 * Generates close button
 *
 * @param {Object} config - options for btn
 * @returns {HTMLElement|string} - button/button string
 */
const createCloseBtn = config => {
    const {customClasses = [], color = '#131313', onClick, htmlStr = false, iconOnly = false, label} = config ?? {};
    const customClassesStr = Array.isArray(customClasses) ? customClasses.join(' ') : '';
    let elStr = ``;

    const svgStr = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none">
   <path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M13.0628 12.002L16.0032 9.06164L14.9426 8.00098L12.0022 10.9413L9.06181 8.00098L8.00115 9.06164L10.9415 12.002L8 14.9435L9.06066 16.0042L12.0022 13.0627L14.9437 16.0042L16.0044 14.9435L13.0628 12.002Z" fill="${color}"/>
</svg>`;

    if (iconOnly) {
        elStr = svgStr;
    } else {
        elStr = `<button type="button" aria-label="${label}" title="${label}" class="${customClassesStr}">${svgStr}</button>`;
    }

    if (htmlStr) {
        return elStr;
    }

    // DOM element
    const el = getDOMfromString(elStr);

    if (onClick) {
        el.onclick = onClick;
    }

    return el;
};

export default createCloseBtn;
